import { MERCHANT_API } from "./site";

const TOKEN_KEY = "dm_merchant_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const isLogged = () => !!getToken();

async function req(path, { method = "GET", body, auth = false, form = false } = {}) {
  const headers = {};
  if (auth) headers.Authorization = `Bearer ${getToken()}`;
  let payload;
  if (form) {
    payload = body;
  } else if (body) {
    headers["Content-Type"] = "application/json";
    payload = JSON.stringify(body);
  }
  const r = await fetch(`${MERCHANT_API}/api${path}`, { method, headers, body: payload });
  let data = {};
  try {
    data = await r.json();
  } catch (_) {
    /* no body */
  }
  if (!r.ok) {
    const msg =
      (data.detail && (data.detail.message || data.detail)) ||
      data.message ||
      `Erro ${r.status}`;
    const err = new Error(typeof msg === "string" ? msg : "Falha na requisição");
    err.status = r.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const registerMerchant = (payload) =>
  req("/merchant/register", { method: "POST", body: payload });

export const loginMerchant = async (identifier, password) => {
  const data = await req("/merchant/login", { method: "POST", body: { cnpj: identifier, password } });
  const token = data.token || data.access_token || data.session_token;
  if (token) setToken(token);
  return data;
};

export const uploadImage = (file) => {
  const f = new FormData();
  f.append("file", file);
  return req("/merchant/upload-image", { method: "POST", auth: true, form: true, body: f });
};

export const updateStore = (patch) =>
  req("/merchant/store", { method: "PUT", auth: true, body: patch });

export const getPlans = () => req("/plans");

export const startSubscription = (plan_id, billing_mode) =>
  req("/merchant/subscription/start", { method: "POST", auth: true, body: { plan_id, billing_mode } });
